var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "170px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "95%",
      "margin": "0 2%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("入职类型：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择入职类型",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.entry_type_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "entry_type_id", $$v)
      },
      expression: "from.entry_type_id"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("招聘方式：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择招聘方式",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.recruitment_method_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "recruitment_method_id", $$v)
      },
      expression: "from.recruitment_method_id"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "induction_time"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("入职时间：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择入职时间",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.induction_time),
      callback: function($$v) {
        _vm.$set(_vm.from, "induction_time", $$v)
      },
      expression: "from.induction_time"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("工龄：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入工龄",
      "size": "small",
      "type": "number",
      "readonly": "readonly"
    },
    model: {
      value: (_vm.from.working_age),
      callback: function($$v) {
        _vm.$set(_vm.from, "working_age", $$v)
      },
      expression: "from.working_age"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "induction_salary"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("入职薪资：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "52%"
    },
    attrs: {
      "placeholder": "请输入入职薪资",
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.from.induction_salary),
      callback: function($$v) {
        _vm.$set(_vm.from, "induction_salary", $$v)
      },
      expression: "from.induction_salary"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("薪资记录")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("入职添加时间：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择入职添加时间",
      "readonly": "readonly",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.induction_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "induction_date", $$v)
      },
      expression: "from.induction_date"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("离职添加时间：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择离职添加时间",
      "readonly": "readonly",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.quit_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "quit_date", $$v)
      },
      expression: "from.quit_date"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("籍贯：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "readonly": "readonly"
    },
    model: {
      value: (_vm.from.native_place),
      callback: function($$v) {
        _vm.$set(_vm.from, "native_place", $$v)
      },
      expression: "from.native_place"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("员工类别：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "readonly": "readonly",
      "disabled": ""
    },
    model: {
      value: (_vm.from.staff_type),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_type", $$v)
      },
      expression: "from.staff_type"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("加入集团日期：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "readonly": "readonly",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.induction_time),
      callback: function($$v) {
        _vm.$set(_vm.from, "induction_time", $$v)
      },
      expression: "from.induction_time"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("所属部门：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.from.project_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "project_name", $$v)
      },
      expression: "from.project_name"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("试用期：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入试用期",
      "size": "small",
      "readonly": "readonly"
    },
    model: {
      value: (_vm.from.probation_period),
      callback: function($$v) {
        _vm.$set(_vm.from, "probation_period", $$v)
      },
      expression: "from.probation_period"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("转正日期：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择转正日期",
      "readonly": "readonly",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.formal_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "formal_date", $$v)
      },
      expression: "from.formal_date"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "post_id"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("所在职位：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所在职位",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.post_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "post_id", $$v)
      },
      expression: "from.post_id"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("薪酬等级：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择薪酬等级",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.pay_grade),
      callback: function($$v) {
        _vm.$set(_vm.from, "pay_grade", $$v)
      },
      expression: "from.pay_grade"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("职级：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择职级",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.rank),
      callback: function($$v) {
        _vm.$set(_vm.from, "rank", $$v)
      },
      expression: "from.rank"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("上级职位：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择上级职位",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.we_chat),
      callback: function($$v) {
        _vm.$set(_vm.from, "we_chat", $$v)
      },
      expression: "from.we_chat"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("上级名称：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择上级名称",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.we_chat),
      callback: function($$v) {
        _vm.$set(_vm.from, "we_chat", $$v)
      },
      expression: "from.we_chat"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("是否兼职：")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.from.is_part_time_job),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_part_time_job", $$v)
      },
      expression: "from.is_part_time_job"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.from.is_part_time_job),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_part_time_job", $$v)
      },
      expression: "from.is_part_time_job"
    }
  }, [_vm._v("否")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("项目经验表：")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("项目经验表")])], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("现薪酬：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入现薪资",
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.from.spare5),
      callback: function($$v) {
        _vm.$set(_vm.from, "spare5", $$v)
      },
      expression: "from.spare5"
    }
  })], 2)], 1)])])])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570167c0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabsEdit/work.vue
// module id = null
// module chunks = 